import useApi from '../use-api';

const route = 'admins/admin-panel/patients/ccm-data';

export const useConsentCcmForm = () => {
  const { loading, updateData } = useApi();

  const consentForm = async (patientGuid: string, ccmConsentForm: boolean) => {
    await updateData(route, {
      patientGuid,
      ccmData: {
        ccmConsentForm,
      },
    });
  };

  return {
    loading,
    consentForm,
  };
};
